// extracted by mini-css-extract-plugin
module.exports = {"mCurated":"yl","flipped":"zl","mainContentContainer":"Al","cta":"Bl","mainContentCtaDefault":"Cl","disabled":"Dl","mainContentCtaWhite":"El"};